export default __webpack_public_path__ + "static/media/bm.458f98ec.svg";